module.exports = __webpack_public_path__ + "static/media/lifeworks_logo.515f16ab.png";